export default {
    data: () => ({
        translations: {
            title: {
                el: "Όνομα εταιρείας",
                en: "Company Name",
                it: "Nome della società"
            },
            description: {
                el: "Επεξεργαστείτε την ονομασία της εταιρείας.",
                en: 'Edit the name of the company.',
                it: "Modificare il nome dell'azienda."
            },
            name: {
                el: "Όνομα",
                en: "Name",
                it: "Nome"
            },
        }
    })
};
